import api from '@/shared/api';
import config from '@/config';

const apiUrl = `${config.appUrls.api}/api/user/dashboard/`;

let cachedLayout = null;

const cleanItem = item => {
  const { i, w, h, x, y } = item;
  return { i, w, h, x, y };
};
const cleanLayout = layout => {
  if (!layout) return null;
  const newlayout = {};
  Object.keys(layout).forEach(bp => {
    newlayout[bp] = layout[bp].map(cleanItem);
  });
  return newlayout;
};

const parseLayoutObject = layout => {
  if (!layout) return null;
  if (typeof layout === 'string') return JSON.parse(layout) || null;
  if (typeof layout === 'object') return layout;
  return null;
};

const parseCachedLayout = () => parseLayoutObject(cachedLayout);

const saveLayout = layout => {
  const cleanedLayout = cleanLayout(parseLayoutObject(layout));
  const data = JSON.stringify(cleanedLayout);
  return api.base
    .put(
      apiUrl,
      `=${data}`, // Little hack to post as string as body
    )
    .then(() => {
      cachedLayout = data;
    });
};

const getLayout = () => {
  if (cachedLayout !== null) return Promise.resolve(parseCachedLayout());
  return api.base.get(apiUrl).then(({ data }) => {
    cachedLayout = data || '';
    return parseCachedLayout();
  });
};

export default {
  save: saveLayout,
  get: getLayout,
};
